import {
  recalculateAutomaticDates,
  sortState,
  updateBookmark,
} from './reducer_functions';

export default function (state, action) {
  switch (action.type) {
    case 'CHANGE_VIEW_OPTIONS':
      var newState = state.set('viewOptions', action.payload.viewOptions);
      return recalculateAutomaticDates(newState);
    case 'TOGGLE_PROJECT':
      return state.setIn(['viewOptions', 'project'], action.payload.toggle);
    case 'TOGGLE_EPICS':
      return state.setIn(
        ['viewOptions', 'releaseEpics'],
        action.payload.toggle
      );
    case 'TOGGLE_INITIATIVES':
      return state.setIn(
        ['viewOptions', 'releaseInitiatives'],
        action.payload.toggle
      );
    case 'TOGGLE_IMPERATIVES':
      return state.setIn(
        ['viewOptions', 'releaseImperatives'],
        action.payload.toggle
      );

    case 'TOGGLE_RELEASE_STATUS':
      return state.setIn(
        ['viewOptions', 'releaseStatus'],
        action.payload.toggle
      );
    case 'TOGGLE_RELEASE_THEME':
      return state.setIn(
        ['viewOptions', 'releaseTheme'],
        action.payload.toggle
      );
    case 'TOGGLE_EXTERNAL_DATES':
      newState = state.setIn(
        ['viewOptions', 'externalDates'],
        action.payload.toggle
      );
      newState = sortState(newState);
      return recalculateAutomaticDates(newState);

    case 'TOGGLE_TAGS':
      return state.setIn(['viewOptions', 'tags'], action.payload.toggle);
    case 'TOGGLE_FEATURE_STATUS':
      return state.setIn(
        ['viewOptions', 'groupedByStatus'],
        action.payload.toggle
      );
    case 'TOGGLE_EPIC_STATUS':
      return state.setIn(
        ['viewOptions', 'groupedByStatus'],
        action.payload.toggle
      );

    case 'TOGGLE_RELEASE_PROGRESS':
      return state.setIn(
        ['viewOptions', 'releaseProgress'],
        action.payload.toggle
      );

    case 'TOGGLE_FEATURE_PROGRESS':
      return state.setIn(
        ['viewOptions', 'recordProgress'],
        action.payload.toggle
      );

    case 'TOGGLE_EPIC_PROGRESS':
      return state.setIn(
        ['viewOptions', 'recordProgress'],
        action.payload.toggle
      );

    case 'TOGGLE_RECORD_IMPERATIVES':
      return state.setIn(
        ['viewOptions', 'recordImperatives'],
        action.payload.toggle
      );
    case 'TOGGLE_RECORD_INITIATIVES':
      return state.setIn(
        ['viewOptions', 'recordInitiatives'],
        action.payload.toggle
      );
    case 'TOGGLE_FEATURE_EPICS':
      return state.setIn(
        ['viewOptions', 'featureEpics'],
        action.payload.toggle
      );
    case 'TOGGLE_RECORD_REFERENCE':
      return state.setIn(
        ['viewOptions', 'recordReference'],
        action.payload.toggle
      );
    case 'CHANGE_MIN_DATE':
      updateBookmark(
        state.get('bookmark').get('id'),
        state.get('bookmark').get('timelineType'),
        {
          configuration_min_date: action.payload.date,
        }
      );
      return state.setIn(
        ['viewOptions', 'dates', 'minDate'],
        action.payload.date
      );
    case 'CHANGE_MAX_DATE':
      updateBookmark(
        state.get('bookmark').get('id'),
        state.get('bookmark').get('timelineType'),
        {
          configuration_max_date: action.payload.date,
        }
      );
      return state.setIn(
        ['viewOptions', 'dates', 'maxDate'],
        action.payload.date
      );

    case 'CHANGE_TIME_SCALE':
      updateBookmark(
        state.get('bookmark').get('id'),
        state.get('bookmark').get('timelineType'),
        {
          configuration_time_scale: action.payload.timeScale,
        }
      );
      return state.setIn(
        ['viewOptions', 'dates', 'timeScale'],
        action.payload.timeScale
      );
    default:
      return state;
  }
}
